// removed by extract-text-webpack-plugin
module.exports = {"component":"_3yzkl1T86G7OWhRXoc-jcL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PreviousStep/previousStep.css
// module id = 1223
// module chunks = 2